// FormThree.js
import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import renderField from "./renderOptionField";

const FormFive = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormFiveSubmit
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");

	const handleNextClick = async event => {
		event.preventDefault();
		handleSubmit(onFormFiveSubmit);
	};

	const options = [
		{ value: "audiovisualResources", label: "Recursos audiovisuais" },
		{ value: "cleaning", label: "Limpeza" },
		{
			value: "openingCocktail",
			label: "Coquetel de Abertura"
		}
	];

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div className="flex-center">
						<h3 className="account__title">
							O que achou da estrutura do evento? (2/2)
						</h3>
					</div>
					<br />
					{options.map(option => (
						<div key={option.value}>
							<div
								className="form__form-group-field"
								// style={{ justifyContent: "space-around" }}
							>
								<div className="form__form-group">
									<label style={{ fontWeight: "bold", fontSize: "16px" }}>
										{option.label}
									</label>
									<div className="form__form-group-field">
										<Field
											name={option.value}
											label={option.label}
											component={renderField}
										/>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>

				{/* Campo oculto para enviar o status como 'ativo' */}
				{/* <Field name="status" component="input" type="hidden" value="ativo" /> */}

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={previousPage}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Próximo"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 5)
})(FormFive);
